module.exports = __webpack_public_path__ + "img/farmers_union.b0f78a61.png";